<div [ngClass]="{'ng-invalid ng-dirty': isCurrentlyInvalid}">
	<label>{{ 'form.field.documentLanguage' | translate }}<span *ngIf="required" class="text-danger">*</span></label>
	<p-dropdown [options]="availableLanguages" optionLabel="name" optionValue="code" [(ngModel)]="_value"
		[inputId]="controlName" placeholder="{{ 'form.field.documentLanguagePlaceholder' | translate }}"
		(onChange)="onInternalChange($event.value)" (onBlur)="propagateTouched()" [showClear]="false"
		[disabled]="_disabled" [styleClass]="isCurrentlyInvalid ? 'p-invalid w-100' : 'w-100'">
	</p-dropdown>
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>